export const parseBatchCode = (text) => {
  const t = (text || "").trim();
  const m = t.match(/\/batch\/([^/?#\s]+)/i);
  return m ? decodeURIComponent(m[1]) : t;
};

export const batchUrl = (base, code) => `${(base || window.location.origin).replace(/\/$/, "")}/batch/${encodeURIComponent(code)}`;
